<template>
  <div class="register2">
    <div class="centered">
      <div>
        <a class="logo" href="https://www.doelbeleggen.nl">
          <img src="../../assets/db/DB-logo3.svg" />
        </a>
        <div v-if="msg.msg && msg.type == 'notice'" :class="['row form-' + msg.type]">
          {{ msg.msg }}
        </div>
        <div class="card">
          <div :class="['visual', registerType === 3 ? 'img1' : 'img2']"></div>
          <template v-if="step == 0">
            <div class="row">
              <div class="sm-col-12 lg-col-6" v-if="registerType === 3">
                <h3>Welkom bij Doelbeleggen</h3>
                Omdat u waarschijnlijk niet voldoende pensioen opbouwt, voorziet de Hypotheekwacht
                van Vereniging Eigen Huis toekomstige problemen met de betaalbaarheid van uw
                hypotheek. In de aanloop naar uw pensioen kunt u het pensioentekort eventueel
                verkleinen, bijvoorbeeld door maandelijks een bedrag te laten beleggen. Voordat we
                een rekening aanvragen, kijken we eerst naar uw doelgegevens en de haalbaarheid.
                <ul>
                  <li>
                    Uw pensioentekort
                    <b>&euro;&nbsp;{{ this.formatPrice(Number(retirementGap)) }}</b
                    >.
                  </li>
                  <li>
                    Te storten bedrag
                    <b
                      >&euro;&nbsp;{{ this.formatPrice(Number(goalResponse.profileC)) }} per
                      maand</b
                    >.
                  </li>
                  <li>
                    Looptijd tot uw pensioenleeftijd <b>{{ durationPeriod }} jaar</b>.
                  </li>
                </ul>
              </div>
              <div class="sm-col-12 lg-col-6" v-if="registerType === 2">
                <h3>Welkom bij Doelbeleggen</h3>
                Met het aanpassen van uw hypotheek verlaagt u uw maand&shy;lasten en creëert u een
                mogelijkheid om extra vermogen op te bouwen. Bij de Hypotheekwacht van Vereniging
                Eigen Huis is de onderstaande beleggings&shy;mogelijkheid bij Doelbeleggen berekend.
                <ul>
                  <li>
                    De besparing van
                    <b>&euro;&nbsp; {{ this.formatPrice(Number(depositAmount)) }} per maand</b>.
                  </li>
                  <li>
                    Looptijd om te beleggen <b>{{ durationPeriod }} jaar</b>.
                  </li>
                  <li>
                    Uw doelvermogen
                    <b>&euro;&nbsp;{{ this.formatPrice(Number(goalResponse.profileC)) }}</b
                    >.
                  </li>
                </ul>
              </div>
              <div class="sm-col-12 lg-col-6 riskmeter" @click="meterModal=true">
                <awesomeIcon icon="info-circle" class="info"/>
                <scoreMeter v-model="satScore" :showNotice="false" />
              </div>
            </div>
            <div class="row">
              <template v-if="durationPeriod < 5">
                Bij kortere looptijden, onder de 5 jaar, beleggen we voorzichtiger. Daarmee kan de
                haalbaarheid lager uitvallen.<br /><br />
              </template>
              <h3>Haalbaarheid van uw doel</h3>
              <template v-if="satScore < 50">
                U ziet in de Doelmeter dat uw doelvermogen lastig haalbaar is, naar het rood gaat.
                Als we beleggen volgens
                <b
                  ><a
                    target="_blank"
                    href="https://www.doelbeleggen.nl/content/uploads/2019/09/Beleggingsprofielen-1-12-2016.pdf"
                    >{{ satProfile }}</a
                  ></b
                >
                dan heeft uw doel een haalbaarheid van
                {{ formatPrice(Number(satScore), false, 0) }}%. Dat is aan de lage kant, alles onder
                50% betekent dat u uw doel moeilijk kunt halen. Dat betekent niet dat u niet verder
                kunt, verderop na het aanmelden kunt u uw doelgegevens aanpassen en de haalbaarheid
                weer beter maken.
              </template>
              <template v-else>
                U ziet in de Doelmeter dat uw doelvermogen goed haalbaar is. Als we beleggen volgens
                ons
                <b
                  ><a
                    target="_blank"
                    href="https://www.doelbeleggen.nl/content/uploads/2019/09/Beleggingsprofielen-1-12-2016.pdf"
                    >{{ satProfile }}</a
                  ></b
                >
                dan heeft uw doel een haalbaarheid van
                {{ formatPrice(Number(satScore), false, 0) }}%. Dat is prima, alles boven 50%
                betekent dat u uw doel kunt halen.
              </template>
            </div>
            <div class="buttonbox">
              <button @click="step = 2" class="primary">Volgende</button>
            </div>
          </template>
          <template v-if="step == 2">
            <div class="row">
              <h3>Hoe kan het beleggen verlopen</h3>
              In deze vermogensverwachting ziet u 3 lijnen. Rood als het beleggen slecht verloopt,
              blauw bij een normaal scenario en de groen als het beleggen beter gaat dan verwacht.
              <projectWidget
                :pvvidata="pvviData"
                :target="retirementGap"
                :enddate="targetDate"
                class="graph"
              />
            </div>
            <div class="buttonbox">
              <button @click="step = 3" class="primary">Volgende</button>
              <button @click="step = 0" class="secondary">Terug</button>
            </div>
          </template>
          <template v-if="step == 3">
            <div class="row">
              <h3>Over Doelbeleggen</h3>
              Wij zijn in 2018 &amp; 2019 uitgeroepen tot Beste Online Vermogensbeheerder van
              Nederland. Door het bieden van laagdrempelig, goedkoop en doelgericht beleggen voor
              mensen die dat niet zelf, maar willen laten doen. Meer informatie kunt u vinden op:
              <a
                href="https://www.doelbeleggen.nl/waarom/"
                target="_blank"
                >doelbeleggen.nl/waarom</a
              >.<br /><br />
              <h3>Aan de slag</h3>
              Na het invullen van e-mail kunt u de doelgegevens verder afstemmen en brengen we uw
              persoonlijke situatie uitgebreid in kaart. Daarmee maken we uw beleggingsplan en
              bepalen we uw uiteindelijke beleggingsprofiel. <br /><br />
              <div v-if="msg.msg && msg.type == 'error'" :class="['row form-' + msg.type]">
                {{ msg.msg }}
              </div>
              <br />
              <form @submit.prevent>
                <input
                  ref="email"
                  name="email"
                  type="email"
                  placeholder="E-mailadres"
                  autofocus
                  @change="msg.msg = null"
                  @keyup.enter="register"
                />
              </form>
            </div>
            <div class="buttonbox">
              <button @click="register" class="primary">Doel afstemmen</button>
              <button @click="step = 2" class="secondary">Terug</button>
            </div>
          </template>
        </div>
        <div class="footer">
          <template v-if="step == 3">
            <a href="https://www.doelbeleggen.nl">Doelbeleggen.nl</a>
            <a href="https://www.doelbeleggen.nl/documentencentrum/privacy-statement/">
              Online Privacy &amp; Beleid
            </a>
          </template>
          <template v-if="step == 3">
            Door het versturen van uw gegevens verleent u Doelbeleggen en met haar verbonden
            ondernemingen in de financiële sector toestemming om u te informeren over onze producten
            en diensten. Zolang dat voor marketingdoeleinden van belang is, worden uw gegevens
            bewaard. Als u hiertegen bezwaar heeft, kunt u een e-mail sturen naar
            info@doelbeleggen.nl. Tevens kunt u zich altijd uitschrijven via de ‘afmelden’ link
            onderin de e-mail. U heeft het recht een verzoek in te dienen om inzage van en
            rectificatie of wissing van uw persoonsgegevens en u heeft het recht een klacht in te
            dienen bij een toezichthoudende autoriteit.
          </template>
          <template v-else>
            De door Doelbeleggen berekende haalbaarheid van uw doel op basis van de door u
            ingevoerde gegevens betreft slechts een verwachting. Deze kan niet met zekerheid worden
            voorspeld. U kunt aan de berekende haalbaarheid dan ook geen rechten ontlenen. Het kan
            niet worden uitgesloten dat u gedurende de looptijd een extra bedrag moet inleggen om
            alsnog uw doel te behalen. De waarde van uw belegging kan fluctueren. In het verleden
            behaalde resultaten bieden geen garantie voor de toekomst. Beleggen door wie en in welke
            vorm dan ook brengt altijd risico’s met zich mee. Zo kunt u (een deel van) uw ingelegde
            vermogen verliezen als gevolg van koersdalingen. Laat u goed voorlichten, zodat u zich
            een gedegen beeld kunt vormen van de risico’s voordat u besluit een rekening te openen.
            Doelbeleggen belegt in indextrackers (ETF’s). Aan trackers zijn bijzondere risico’s
            verbonden, zoals koers- , geografisch- en sectorrisico. Doelbeleggen is een initiatief
            en handelsnaam van Velthuyse • Mulder Vermogensbeheer B.V. en staat als
            beleggingsonderneming geregistreerd bij de Autoriteit Financiële Markten te Amsterdam.
          </template>
        </div>
      </div>
    </div>
    <!-- metermodal -->
    <modalWindow v-show="meterModal" @close="meterModal = false">
      <div class="titlebar">Profiel</div>
      <div class="inset">
        De Doelmeter geeft aan dat uw doel de grootste haalbaarheid heeft wanneer u gaat beleggen in
        Profiel {{ satProfile }}.
        <br /><br />
        <a
          target="_blank" class="button"
          href="https://www.doelbeleggen.nl/content/uploads/Beleggingsprofielen.pdf"
        >
          <awesomeIcon icon="file-alt"/> Bekijk onze beleggingsprofielen
        </a>
        <br /><br /><b>Haalbaarheid</b><br>
        Hoe hoger de haalbaarheid, hoe beter. Zo geeft een haalbaar­heid van minder dan 50% aan dat
        uw doel onzekerder wordt. Met een haalbaar­heid van 50% en hoger bouwt u een buffer voor
        mindere tijden.<br><br>
        Om uw haalbaarheid te verhogen, kunt u de inleg verhogen en/of looptijd verlengen. U kunt
        uiteraard ook altijd bellen met onze adviseurs op 020-5550055.
      </div>
    </modalWindow>
  </div>
</template>

<script>
import scoreMeter from '../ui/scoreMeter';
import projectWidget from '../intake/project2';

export default {
  components: {
    scoreMeter,
    projectWidget,
  },
  name: 'RegisterPageVEH',
  data() {
    return {
      style: process.env.STYLE,
      msg: { msg: null, type: 'notice' },
      step: 0,
      registerType: Number(this.getQueryVariable('register')),
      depositAmount: Number(this.getQueryVariable('inleg')),
      retirementGap: Number(this.getQueryVariable('tekort')),
      durationPeriod: this.getQueryVariable('looptijd'),
      goalResponse: {},
      satScore: 50,
      pvviData: {},
      targetDate: '',
      meterModal: false,
      satProfile: 'Doelbeleggen E',
    };
  },
  mounted() {
    if (this.registerType === 3) {
      if (!(this.retirementGap > 1000 && this.durationPeriod > 0 && this.durationPeriod < 100)) {
        this.retirementGap = 10000;
        this.durationPeriod = '8';
        this.msg.msg = "Uw gegevens ontbreken, daarom ziet u de standaard doelgegevens. Om uw situatie voor u te kunnen berekenen, dient u eerst terug te keren naar de Hypotheekwacht. Klik vervolgens opnieuw 'Naar doelbeleggen.nl'.";
      }
      this.sdk.getGoal({ years: this.durationPeriod, goal: this.retirementGap }, (response) => {
        if (response.status === 200) {
          this.goalResponse = response.data;
          this.sat();
        }
      });
    }
    if (this.registerType === 2) {
      if (
        !(
          this.depositAmount > 10
          && this.depositAmount < 100000
          && this.durationPeriod > 1
          && this.durationPeriod < 99
        )
      ) {
        this.retirementGap = 200;
        this.durationPeriod = '8';
        this.msg.msg = "Uw gegevens ontbreken, daarom ziet u de standaard doelgegevens. Om uw situatie voor u te kunnen berekenen, dient u eerst terug te keren naar de Hypotheekwacht. Klik vervolgens opnieuw 'Naar doelbeleggen.nl'.";
      }
      this.sdk.getProfit(
        { years: this.durationPeriod, monthly: this.depositAmount },
        (response) => {
          if (response.status === 200) {
            this.goalResponse = response.data;
            this.sat();
          }
        },
      );
    }
  },
  methods: {
    sat() {
      this.sdk.freeSat(
        // goalValue
        this.registerType === 3 ? this.retirementGap : Number(this.goalResponse.profileC),
        // years
        this.durationPeriod,
        // start
        this.registerType === 3 ? Number(this.goalResponse.profileC) : this.depositAmount,
        // depositValue
        this.registerType === 3 ? Number(this.goalResponse.profileC) : this.depositAmount,
        // depositInterval
        'M',
        // profile
        '',
        // response
        (response) => {
          if (response.status === 200) {
            this.satScore = response.data.score;
            this.pvviData = response.data.pvvidata;
            this.setProfile(response.data.pvvidata[0].vProfile);
            this.targetDate = response.data.otp
              .match('targetDate=[0-9]{4}-[0-9]{2}-[0-9]{2}')[0]
              .slice(11);
          }
        },
      );
    },
    register() {
      this.sdk.register(
        // username
        this.$refs.email.value,
        // email
        this.$refs.email.value,
        // callback
        (response) => {
          if (response.status === 200) {
            window.location.href = `?intake=${response.data.intake}`;
          } else if (response.status === 401) {
            this.msg = { msg: 'E-mailadres al in gebruik.', type: 'notice' };
          } else if (response.status === 403) {
            this.msg = { msg: 'E-mailadres incorrect.', type: 'notice' };
            this.msg.type = 'error';
          } else {
            this.msg = { msg: 'API onbereikbaar, probeer later opnieuw', type: 'notice' };
          }
        },
        // goal
        'grote-aankoop',
        // advisor
        '22223',
        // monthly
        this.registerType === 3 ? String(this.goalResponse.profileC) : String(this.depositAmount),
        // years
        String(this.durationPeriod),
        // target
        this.registerType === 3 ? String(this.retirementGap) : String(this.goalResponse.profileC),
      );
    },
    setProfile(profile) {
      if (profile === 'DB6') {
        this.satProfile = 'Doelbeleggen E';
      } else if (profile === 'DB5') {
        this.satProfile = 'Doelbeleggen D';
      } else if (profile === 'DB4') {
        this.satProfile = 'Doelbeleggen C';
      } else if (profile === 'DB3') {
        this.satProfile = 'Doelbeleggen B';
      } else if (profile === 'DB2') {
        this.satProfile = 'Doelbeleggen A';
      } else if (profile === 'DB1') {
        this.satProfile = 'Sparen';
      } else {
        this.satProfile = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.register2 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
@keyframes fadeInFromNone {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.logo {
  display: block;
  margin: 8% auto 40px;
  width: 250px;
  @media #{$mobile} {
    margin-top: 20px;
  }
}
.footer {
  margin: 40px auto;
  text-align: justify;
  max-width: 720px;
  color: rgba(255, 255, 255, 0.5);
  a {
    display: block;
    color: #fff;
    text-align: center;
    &:last-child {
      margin-bottom: 10px;
    }
  }
}
.form-error,
.form-notice,
.form-success {
  border-radius: 2px;
  max-width: 800px;
  margin: 0 auto 20px;
}
.formgroup {
  input[type='radio'] {
    width: auto;
    margin-right: 10px;
  }
  label {
    float: left;
    clear: left;
    margin-bottom: 10px;
  }
}
.card {
  border-radius: 4px;
  color: $color-background;
  overflow: hidden;
  background-color: $color-lightgrey2;
  margin-top: 20px;
  max-width: 800px;
  margin: 0 auto;
  box-sizing: border-box;
  @media #{$desktop} {
    padding: 40px;
    padding-bottom: 100px;
    padding-left: 240px;
  }
  @media #{$mobile} {
    padding: 20px;
    padding-bottom: 80px;
  }
  p,
  h2 {
    color: $color-background;
    margin: 20px 0px 20px 0px;
    width: 100%;
  }
  h3 {
    margin-bottom: 5px;
  }
  a {
    text-decoration: underline;
  }
  .buttonbox {
    position: absolute;
    @media #{$desktop} {
      bottom: 30px;
      right: 30px;
    }
    @media #{$mobile} {
      bottom: 20px;
      right: 20px;
    }
    button {
      float: right;
      &.secondary {
        padding: 10px 20px;
        margin-right: 20px;
      }
    }
  }
  .riskmeter {
    cursor: pointer;
    border-radius: 4px;
    &:hover {
      background-color: rgba(0,0,0,.1);
    }
    @media #{$mobile} {
      padding: 0 30px;
      margin-bottom: -20px;
    }
    .info {
      float: right;
      margin-top: 5px;
      margin-right: 5px;
    }
  }
  ul {
    padding-left: 12px;
  }
  @media #{$desktop} {
    .visual {
      width: 200px;
      background-color: #000;
      top: 0;
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 1;
      background-position: center;
      &.img1 {
        background-image: url('../../assets/db/veh1-highres-600x300.jpg');
      }
      &.img2 {
        background-image: url('../../assets/db/veh2-highres-600x300.jpg');
      }
    }
  }
  .graph {
    margin-top: 20px;
  }
}
</style>
